import PropTypes from 'prop-types';
import { useScopeCheck } from '../scopes';
import ManagerChips from './ManagerChips';

ManagerChipsWrapper.propTypes = {
  onDeleteSuccess: PropTypes.func,
  type: PropTypes.string,
  props: PropTypes.object,
  refetch: PropTypes.func,
  showAllManagers: PropTypes.bool,
};

export default function ManagerChipsWrapper(onDeleteSuccess, type, refetch = null, noFlex = false, props, showAllManagers = true) {
  const hasFacilityAccess = useScopeCheck(['Facility-Manager'], true);
  
  return {
    field: 'manager',
    overrideArray: 'facilityManagerAssignments',
    headerName: 'Manager',
    type: 'customSelect',
    minWidth: 150,
    flex: !noFlex ? 1.5 : 0,
    customFilterOperators: ['hasAnyOf', 'containsAnySubstring'],
    getFilterValues: (row) => row.facilityManagerAssignments?.map((manager) => manager.manager),
    valueGetter: (params) => params.row.facilityManagerAssignments?.map((manager) => manager.manager).join(', ') ?? '',
    renderCell: (params) => (
      <ManagerChips
        params={params}
        hasFacilityAccess={hasFacilityAccess}
        onDeleteSuccess={onDeleteSuccess}
        type={type}
        refetch={refetch}
        showAllManagers={showAllManagers}
      />
    ),
    ...props,
  };
}
